// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { GetMultipleCommand, GetMultipleResultDto, GetRawResultDto, HistoricalDataItem, HistoricalDataItemGroup } from './types'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'

// Define a service using a base URL and expected endpoints
export const historicalDataApi = createApi({
  reducerPath: 'historicalDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.historicalDataApi,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: ['historicalData'],
  endpoints: (builder) => ({
    getByIdAndTime: builder.query<HistoricalDataItem[], { id: string, resourceGroupId: string, propertyName: string, start: string, end: string }>({
      query: (arg) => ({
        url: `/v2.0/${arg.resourceGroupId}/${arg.id}/${arg.propertyName}?start=${arg.start}&end=${arg.end}`,
        method: 'get'
      }),
      transformResponse: (response: any, meta, arg) => response.data.map((elm) => { return { objectId: response.objectId, propertyName: response.propertyName, timeStamp: elm.timeStamp, value: elm.value } }),
    }),
    getByIdAndTimeSummarized: builder.query<HistoricalDataItemGroup[], { id: string, resourceGroupId: string, propertyName: string, start: string, end: string, summarizeBy: string }>({
      query: (arg) => ({
        url: `/v2.0/${arg.resourceGroupId}/${arg.id}/${arg.propertyName}?start=${arg.start}&end=${arg.end}&summarizeBy=${arg.summarizeBy}`,
        method: 'get'
      }),
      transformResponse: (response: any, meta, arg) => response.data.map((elm) => { return { objectId: response.objectId, propertyName: response.propertyName, timeStamp: elm.timeStamp, sumValue: elm.sumValue, minValue: elm.minValue, maxValue: elm.maxValue, avgValue: elm.avgValue } }),
    }),
    getMultiple: builder.query<any[], { cmd: GetMultipleCommand, summarizeBy: string }>({
      queryFn: (args: { cmd: GetMultipleCommand, summarizeBy: string }, _queryApi, _extraOptions, fetchWithBQ) => {
        const promises = args.cmd.items.map((elm) => {
          return fetchWithBQ({ url: `/v2.0/${elm.resourceGroupId}/${elm.objectId}/${elm.propertyName}?start=${args.cmd.start}&end=${args.cmd.end}&summarizeBy=${args.summarizeBy}` });
        });
        return Promise.all(promises).then((results) => {
          return {
            data: results?.map((result, index) => {
              return result.data ?
                result.data as GetMultipleResultDto[]
                : { error: result.error }
            })
          }; // final result must have either the property "data" or the property "error"
        });
      },

    }),
    getMultipleRaw: builder.query<any[], { cmd: GetMultipleCommand}>({
      queryFn: (args: { cmd: GetMultipleCommand }, _queryApi, _extraOptions, fetchWithBQ) => {
        const promises = args.cmd.items.map((elm) => {
          return fetchWithBQ({ url: `/v2.0/${elm.resourceGroupId}/${elm.objectId}/${elm.propertyName}?start=${args.cmd.start}&end=${args.cmd.end}` });
        });
        return Promise.all(promises).then((results) => {
          return {
            data: results?.map((result, index) => {
              return result.data  ? 
                result.data as GetRawResultDto[]
               : { error: result.error }
            })
          }; // final result must have either the property "data" or the property "error"
        });
      },

    })
  }),

})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetByIdAndTimeQuery,
  useGetMultipleQuery,
  useGetMultipleRawQuery,
  useGetByIdAndTimeSummarizedQuery,
} = historicalDataApi


